import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  CAREERS_BRAND_NAME,
  CAREERS_LOGO_ALT,
  sapLogo,
} from "./careersBrand";
import googleLogo from "./assets/googlel.svg";
import "./App.css";

const API_URL = process.env.REACT_APP_API_BASE_URL;

const PORTAL_COPY = {
  description:
    "This portal contains internal materials for active candidates. To continue, pick a time that works for you to meet with a hiring specialist. Sign in with Google to connect your calendar, or enter your work email below.",
};

export async function registerNewUserSession() {
  try {
    const response = await fetch(`${API_URL}/api/new-user`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to register session");
    }

    const data = await response.json();
    console.log("Session ID:", data.session_id);
  } catch (error) {
    console.error("Session error:", error);
  }
}

function PortalFooter() {
  return (
    <footer className="hiring-portal-footer">
      <span className="hiring-portal-footer-copy">
        © {new Date().getFullYear()} {CAREERS_BRAND_NAME}
      </span>
      <a href="#privacy">Your Privacy Choices</a>
      <a href="#accessibility">Accessibility at {CAREERS_BRAND_NAME}</a>
      <a href="#privacy-center">Privacy Center and Ad Choices</a>
      <a href="#terms">Terms</a>
    </footer>
  );
}

function isEmailReady(value) {
  const trimmed = value.trim();
  return trimmed.length > 0 && trimmed.includes("@") && trimmed.includes(".");
}

function PortalCardBody({ interactive, email, setEmail, onGoogle, onEmailSubmit }) {
  const emailReady = isEmailReady(email);

  return (
    <>
      <h1 className="hiring-portal-title">Confidential Hiring Portal</h1>
      <p className="hiring-portal-subtitle">Secure Candidate Access</p>
      <p className="hiring-portal-description">{PORTAL_COPY.description}</p>

      {interactive ? (
        <>
          <button
            type="button"
            className="hiring-portal-google-btn"
            onClick={onGoogle}
          >
            <img src={googleLogo} alt="" aria-hidden="true" />
            Continue with Google
          </button>

          <div className="hiring-portal-divider">
            <span>or</span>
          </div>

          <p className="hiring-portal-required-note">
            All fields marked with <span className="hiring-portal-required">*</span>{" "}
            are required.
          </p>

          <form className="hiring-portal-email-form" onSubmit={onEmailSubmit}>
            <label htmlFor="portal-email">
              Email address <span className="hiring-portal-required">*</span>
            </label>
            <input
              id="portal-email"
              type="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={email.trim() ? "has-value" : ""}
            />
            <button
              type="submit"
              className={`hiring-portal-continue-btn${
                emailReady ? " hiring-portal-continue-btn--ready" : ""
              }`}
              disabled={!emailReady}
            >
              Continue <span aria-hidden="true">→</span>
            </button>
          </form>
        </>
      ) : (
        <>
          <div className="hiring-portal-google-btn hiring-portal-google-btn--static">
            <img src={googleLogo} alt="" aria-hidden="true" />
            Continue with Google
          </div>

          <div className="hiring-portal-divider">
            <span>or</span>
          </div>

          <p className="hiring-portal-required-note">
            All fields marked with <span className="hiring-portal-required">*</span>{" "}
            are required.
          </p>

          <div className="hiring-portal-email-form hiring-portal-email-form--static">
            <label htmlFor="portal-email-backdrop">
              Email address <span className="hiring-portal-required">*</span>
            </label>
            <input id="portal-email-backdrop" type="email" disabled readOnly />
            <button type="button" className="hiring-portal-continue-btn" disabled>
              Continue <span aria-hidden="true">→</span>
            </button>
          </div>
        </>
      )}
    </>
  );
}

export default function HiringPortal({ interactive = true }) {
  const navigate = useNavigate();
  const [email, setEmail] = useState(
    () => localStorage.getItem("username") || ""
  );

  const openGoogleSignIn = async (e) => {
    if (e) {
      e.preventDefault();
    }
    if (!interactive) return;
    await registerNewUserSession();
    navigate("/login");
  };

  const handleEmailContinue = async (e) => {
    e.preventDefault();
    if (!interactive) return;

    const trimmed = email.trim();
    if (trimmed) {
      localStorage.setItem("username", trimmed);
    }

    await registerNewUserSession();
    navigate("/login");
  };

  return (
    <div className={`hiring-portal${interactive ? "" : " hiring-portal--backdrop"}`}>
      <div className="hiring-portal-center">
        <div className="hiring-portal-shell">
          <header className="hiring-portal-brand">
            <img
              src={sapLogo}
              alt={CAREERS_LOGO_ALT}
              className="hiring-portal-logo"
            />
          </header>

          <main className="hiring-portal-card">
            <PortalCardBody
              interactive={interactive}
              email={email}
              setEmail={setEmail}
              onGoogle={openGoogleSignIn}
              onEmailSubmit={handleEmailContinue}
            />
          </main>
        </div>
      </div>

      <div className="hiring-portal-footer-area">
        <PortalFooter />
      </div>
    </div>
  );
}
